var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChromeNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3607_20946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9566 0.974098C11.9566 0.974098 19.032 0.656247 22.782 7.75305H11.3551C11.3551 7.75305 9.19721 7.68229 7.35742 10.2953C6.82701 11.3901 6.26108 12.52 6.89775 14.7441C5.97789 13.1909 2.01562 6.30559 2.01562 6.30559C2.01562 6.30559 4.81056 1.25639 11.9566 0.974098Z",
    fill: "#E14C40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.413 18.9952C22.413 18.9952 19.1504 25.2689 11.1172 24.9607C12.1083 23.2487 16.8319 15.0847 16.8319 15.0847C16.8319 15.0847 17.9724 13.2551 16.626 10.3586C15.9414 9.35241 15.2441 8.29813 12.9956 7.73586C14.8039 7.71813 22.7588 7.73707 22.7588 7.73707C22.7588 7.73707 25.7416 12.6778 22.413 18.9952Z",
    fill: "#FFD24D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.55483 19.0428C1.55483 19.0428 -2.25752 13.085 2.02718 6.29608L7.73833 16.1744C7.73833 16.1744 8.75565 18.0749 11.9425 18.3594C13.1577 18.2709 14.4209 18.1955 16.0329 16.5334C15.1444 18.105 11.1498 24.9716 11.1498 24.9716C11.1498 24.9716 5.37157 25.0791 1.55483 19.0428Z",
    fill: "#00AA60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58594 13.0724C6.58594 10.1218 8.9827 7.72927 11.9396 7.72927C14.8964 7.72927 17.2929 10.1218 17.2929 13.0724C17.2929 16.0239 14.8964 18.416 11.9396 18.416C8.9827 18.416 6.58594 16.024 6.58594 13.0724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73438 13.0708C7.73438 10.7571 9.61394 8.88117 11.9324 8.88117C14.2501 8.88117 16.13 10.7571 16.13 13.0708C16.13 15.3849 14.2502 17.2607 11.9324 17.2607C9.61394 17.2607 7.73438 15.3848 7.73438 13.0708Z",
    fill: "#577FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9526 0.977011C11.9526 0.977011 16.6237 0.767206 20.3866 4.49507C20.3248 4.49507 7.53764 4.53613 3.42969 4.53613C4.91548 3.05165 7.6427 1.14739 11.9526 0.977097",
    fill: "#D6483E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3607_20946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeNew);
export default __webpack_public_path__ + "static/media/ChromeNew.f0d655c3d9d655153d921e4a83a26093.svg";
export { ForwardRef as ReactComponent };